'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _translate = require('../../language/translate');

var _step2Functions = require('../../helpers/step2Functions');

exports.default = function (values, props) {
  var allApplicants = props.form.applicants ? props.form.applicants.concat(props.form.applicant) : [props.form.applicant];
  return _extends({
    applicant: values.applicant.map(function (applicant, i) {
      var x = i + 1;
      return {
        sex: !applicant.sex && (0, _translate.t)('Applicant %(index)d: Gender is Required', { index: x }),
        address_line_1: i === 0 && !applicant.address_line_1 && (0, _translate.t)('Address Line 1 is Required'),
        city: i === 0 && !applicant.city && (0, _translate.t)('City is Required'),
        state: i === 0 && !applicant.state && (0, _translate.t)('Province is Required'),
        postal_code: i === 0 && !applicant.postal_code && (0, _translate.t)('Postal Code is Required'),
        phone: i === 0 && !applicant.phone && (0, _translate.t)('Phone Number is Required')
      };
    })
  }, (0, _step2Functions.validatePayment)(values));
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/oop/Applicants.js
// module id = 1755
// module chunks = 0